import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useGlobalContext } from "@/hooks/useGlobalContext";
import { Post } from "@/constants/types";
import { useLanguage } from "@/context/LanguageContext";
import Link from "next/link";

const SliderSection = () => {
  const { t } = useLanguage();
  const { sliders } = useGlobalContext();
  return (
    sliders &&
    sliders.length > 0 && (
      <div className="tp-slider-3__area p-relative">
        <div className="tp-slider-3__icon smooth">
          <a href="#service" className="arrow-scroll-btn">
            <i className="flaticon-down-arrow"></i>
          </a>
        </div>
        <div className="tp-slider-3__arrow-box">
          <button className="test-prev">
            <svg
              id="body"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="67"
              height="24"
              viewBox="0 0 67 24"
            >
              <g id="hero_area" data-name="hero area">
                <g id="slider_arrow" data-name="slider arrow">
                  <g id="next">
                    <image
                      id="right-arrow"
                      width="67"
                      height="24"
                      xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAYCAYAAAChg0BHAAABwElEQVRYheXZzatNYRTH8c+90WXgZXAJJTMKJddbCRmQkZn/xlzJwMR/wcRA6ooRQoiJtygvMxTFwC3u0aq162l33XPOwLPZ5zvaa59O5/f8Wnvt3/OcqcFgYAwuYQfO4sE4X/wfWDGGxss4k9eLODWpZszjZF4v4Pxf1NQZo5hRGvED+/Csh14MNeMGThT18b4aEUwv89l8YcR3HMT9Sro6YanOWIXr2QWNEQfwos9GBO1X60o8xu6sv+DwJBhhic64VRjRdMSbDnR1QjMzVuMhjmQds2HNJBkhO2Mt7hQdETniKo5ic8f6ahAN8RM3Y2a8xPbiRxeHvGX6yvtY9GxrcZNoRDAbnbE1N12b8makzHN4jY0dC6zBFH5FnGherVtwD2FM3LiG0723oUWZM9bhLnZm/QFz+PwvCK1BO3Stx/PikXmXWeNTL1ffoj0sv7Z2pdvwCBs6VVmJP510zWTw2pN1PDLH8LZvBpQsd+w3kzNkLutv2I9X1VVWYtgZ6HRu3JoOiWG6Cx/7YkDJsIAVafQQnmYdAe0J9taTWI9R0uZCGnI769ivXOjD4tuMeiAchsTG7Ur+VXCxnsRK4DeksGLGpvQizQAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <button className="test-next">
            <svg
              id="body2"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="66"
              height="24"
              viewBox="0 0 66 24"
            >
              <g id="hero_area2" data-name="hero area">
                <g id="slider_arrow2" data-name="slider arrow">
                  <g id="prev">
                    <image
                      id="right-arrow2"
                      width="66"
                      height="24"
                      xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAYCAYAAABOQSt5AAABZUlEQVRYheWYsUoDQRCGPzWtNsFGCPgAFmKiEgniCwiWop1l8gYarJJ3sfAlLAIhEGICiohgaydERGxcGZnAulyyKgR19ofh9o69292P+dnZm3HOYVD7wClwrteorIK4B5a13QTqsRdmpz+nX9GxN+gJ0IhOQjLCaFTdZ9UnrdMyCIlaAKORKgiJw6/ASAEEGTZppgqCmE1SAsEkm6QGQmLXOfcc2iSnu+gmfLTfzFQS2ZLqsQ+cAUfaQ2oOJ5VlC9j6azOesobAgj+EgDBZY39XYocKsAfMaepY1wOwChx46+xaPXTFdAFsa59bAZP7+bf+pfLAAFjSyUt7B3ixevrMkhzLex4E2T02gEcM/48IJYu/Aeb1+R2wAryO+qWQEYtA24MgmVD0IZAACLFDFyjofV+Lx2HY0bI1QjtcA2thJoxkNSMKGXYojYOA4YzoAOvaHujuMBYChjPiCngCLoFyDALAO8rQx5NO39/uAAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </button>
        </div>
        <div className="tp-slider-3__wrapper">
          <div className="swiper-container tp-slider-3__active">
            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={0}
              slidesPerView={1}
              loop={true}
              navigation={{
                nextEl: ".test-next",
                prevEl: ".test-prev",
              }}
              autoplay={{ delay: 10000 }}
              className="swiper-wrapper"
            >
              {sliders?.map((slider: Post, index: number) => (
                <SwiperSlide key={index}>
                  <div className="swiper-slide">
                    <div
                      className="tp-slider-3__bg z-index fix p-relative"
                      style={{
                        backgroundImage: `url(${slider.image})`,
                      }}
                    >
                      <div className="tp-slider-3__shape"></div>
                      <div className="tp-slider-3__text">
                        <h3 className="tp-slider-3__big-text">{slider.type}</h3>
                      </div>
                      <div className="container">
                        <div className="row">
                          <div className="col-xl-12">
                            <div className="tp-slider-3__content text-center">
                              <span className="tp-slider-3-subtitle">
                                {slider.type}
                              </span>
                              <h2 className="tp-slider-3-title pb-30">
                                {slider.title}
                              </h2>
                              <Link
                                className="tp-btn theme-2-bg"
                                href={
                                  slider.type === "ACTIVITY"
                                    ? `/activities/${slider.slug}`
                                    : slider.type === "DOMAINE"
                                    ? `/area/${slider.slug}`
                                    : slider.type === "BLOG"
                                    ? `/blog/${slider.slug}`
                                    : (undefined as any)
                                }
                              >
                                {t("ReadMore")}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    )
  );
};

export default SliderSection;
